export const accessToken = () => {
  let token = localStorage.getItem("token");
  if (token) return token;
  else return false;
};

export const role = () => {
  let role = localStorage.getItem("role");
  if (role) return role;
  else return false;
};

export const publicAddress = () => {
  let wagmiStroe = JSON.parse(localStorage.getItem("wagmi.store"));
  let { data } = wagmiStroe?.state ?? {};
  if (data?.account) {
    return data?.account;
  } else return null; // Return null instead of false for better conditional handling
};
export const isSignMessageShowed = () => {
  let data = localStorage.getItem("isSignMessageShowed");

  if (data) {
    return data;
  } else return false;
};

export const localSignature = () => {
  let data = localStorage.getItem("signature");
  if (data) {
    return data;
  } else return false;
};

export const signupPopupShown = () => {
  let data = localStorage.getItem("signupPopupShown");
  if (data) {
    return data;
  } else return false;
};

export const walletData = () => {
  let data = JSON.parse(localStorage.getItem("walletData"));
  if (data) {
    return data;
  } else return false;
};
export const inProgressAction = () => {
  let data = localStorage.getItem("in-progress-action");
  if (data) {
    return JSON.parse(data);
  } else return false;
};
export const handleRemoveLocalData = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("isSignMessageShowed");
  localStorage.removeItem("role");
};

export const localTokenPrices = () => {
  const data = JSON.parse(localStorage.getItem("token-prices"));
  if (data) {
    return data;
  }
};
